import { apiKey as llmApiKey } from '@rocketlane/rocket-llm';
import { ApiKey } from './api-key';
/**
 * Keeps the chat client's key in step with the app's key. Nothing else sets it, so the stream
 * falls back to a Bearer stream token that rocket-api rejects with 401.
 */ export const syncRocketLlmApiKey = ()=>ApiKey.tokens().subscribe((value)=>{
        if (value) {
            llmApiKey.set(value);
        } else {
            llmApiKey.clear();
        }
    });
